import { useState, useEffect } from 'react';

/**
 * 实时时间Hook
 * @param updateInterval 更新间隔（毫秒），默认1000ms
 * @returns 当前时间对象
 */
export const useCurrentTime = (updateInterval: number = 1000): Date => {
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, updateInterval);

    return () => clearInterval(timer);
  }, [updateInterval]);

  return currentTime;
};